export default {
  addOns: 'Tambahan',
  availability: 'Ketersediaan',
  availabilityDaySelector: 'Pemilih tanggal ketersediaan',
  unavailable: 'Tidak tersedia',
  person: 'orang',
  people: 'orang',
  reserveNow: 'Pesan sekarang',
  selectTime: 'Pilih waktu',
  select: 'Pilih',
  reserve: 'Pesan',
  time: 'Waktu',
  tier: 'Tingkat',
  questions: 'Pertanyaan',
  addToCart: 'Tambahkan ke keranjang',
  checkout: 'Pembayaran',
  total: 'Total',
  whatsIncluded: 'Apa yang termasuk',
  showMore: 'Tampilkan lebih banyak',
  showLess: 'Tampilkan lebih sedikit',
  session: 'Sesi',
  viewDetails: 'Lihat detail',
  findAvailability: 'Cari Ketersediaan',
  loading: 'Memuat',
  capacity: 'Kapasitas',
  noAvailableSessionsOnThisDate: 'Tidak ada sesi tersedia pada tanggal ini',
  noGroupAvailableOnThisDateAndTime:
    'Tidak ada {{groupTitle}} tersedia pada tanggal dan waktu ini',
  noCollectionFound: 'Koleksi tidak ditemukan!',
  noResourceGroupFound: 'Grup sumber daya tidak ditemukan!',
  noData: 'Tidak ada data!',
  continue: 'Lanjutkan',
  night: 'malam',
  nights: 'malam',
  noAvailableSessionsForSelectedDates:
    'Beberapa tanggal dalam pilihan Anda tidak memiliki sesi yang tersedia. Silakan pilih tanggal yang berbeda.',
  from: 'dari',
  dateRangeSelector: 'Pemilih rentang tanggal',
  priceTierRadioGroup: 'Pemilih tingkat harga',
  startTime: 'Waktu mulai',
  duration: 'Durasi',
  lengthOfStay: 'Lama menginap',
  startDate: 'Tanggal mulai',
  endDate: 'Tanggal selesai',
  selectDates: 'Pilih tanggal',
  more: 'Lainnya',
  selectStartTime: 'Pilih waktu mulai',
  endTime: 'Waktu selesai',
  selectEndTime: 'Pilih waktu selesai',
  morning: 'Pagi',
  afternoon: 'Siang',
  save: 'Simpan',
  selectDuration: 'Pilih durasi',
  forLength: 'untuk {{length}}',
  moreDates: '{{count}} lagi',
  addDate: 'Tambah tanggal',
  start: 'Mulai',
  end: 'Selesai',
  pickupFrom: 'Pengambilan mulai',
  returnBy: 'Pengembalian paling lambat',
  day: 'hari',
  days: 'hari',
  hour: 'jam',
  hours: 'jam',
};
